import './home.scss';
import React from 'react';
import { Translate, translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}

      <section id="hero">
        <Row className="align-items-center">
          {/* Resim */}
          <Col lg="6" className="order-1 order-lg-2">
            <img src="/content/images/home-start.png" alt="Hero" className="img-fluid" />
          </Col>

          {/* Yazı */}
          <Col lg="6" className="order-2 order-lg-1">
            <h1>{translate('home.section1.h1')}</h1>
            <h2>
              <Translate contentKey="home.section1.h2" />
            </h2>
            <div className="hero-buttons d-flex flex-wrap">
              <a href="#about" className="btn btn-primary">
                {translate('home.section1.getstared')}
              </a>
              <a href="#offer" className="btn btn-outline-primary">
                {translate('home.section1.h1.getoffer')}
              </a>
            </div>
          </Col>
        </Row>
      </section>

      {/* Offer Section */}
      <section id="offer" className="about">
        <Row>
          <Col md="6">
            <h3>{translate('home.section1.h1.getofferapp.header')}</h3>
            <p>
              <Translate contentKey="home.section1.h1.getofferapp.detail" />
            </p>
            <div className="hero-buttons d-flex">
              <a
                href="mailto:yilmaz@startupsreactor.com
    ?subject=Contact%20Request
    &body=Hello%20Startups%20Reactor,%0A%0AI%20would%20like%20to%20get%20more%20information."
                //  href="#/project/wizard"
                className=" btn btn-outline-primary"
              >
                {translate('home.section1.h1.getoffer')}
              </a>
            </div>
          </Col>
          <Col md="6">
            <h3>{translate('home.section1.h1.getofferops.header')}</h3>
            <p>
              <Translate contentKey="home.section1.h1.getofferops.detail" />
            </p>
            <div className="hero-buttons d-flex">
              <a href="#" className="btn btn-outline-primary">
                {translate('home.section1.h1.getofferops')}
              </a>
            </div>
          </Col>
        </Row>
      </section>

      {/* Provided Services */}
      <section id="services" className="about">
        <div className="ml-5">
          <div className="row">
            <div className="col-md-6 order-1 order-md-2 align-self-center" data-aos="fade-left">
              <img src="/content/images/template/pc-start.png" className="img-fluid" alt="" />
            </div>
            <div className="col-md-6 pt-5 order-2 order-md-1" data-aos="fade-up">
              <h3 id="provided">{translate('home.sectionservices.title')} </h3>
              <p>{translate('home.sectionservices.paragraf')}</p>

              {['1', '2', '3', '4', '5', '6'].map(x => (
                <div key={x} className="icon-box" data-aos="zoom-in" data-aos-delay="100">
                  <div className="icon" style={{ backgroundColor: '#e62333' }}>
                    {/* <FontAwesomeIcon size="2x" icon={translate("home.sectionservices.list." + x + ".image")} /> */}
                    <img src={translate('home.sectionservices.list.' + x + '.image')} alt="" />
                  </div>
                  <div className="title">
                    <a href={translate('home.sectionservices.list.' + x + '.href')}>
                      {' '}
                      {translate('home.sectionservices.list.' + x + '.title')}
                    </a>
                  </div>
                  <p className="description">{translate('home.sectionservices.list.' + x + '.description')}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* About / Opportunities */}

      <section id="about" className="about">
        <div className="ml-5">
          <div className="row">
            <div className="col-xl-6 col-lg-6 video-box d-flex justify-content-center align-items-stretch" data-aos="fade-right">
              <a
                href="https://www.youtube.com/watch?v=ImUcJctyUQ0"
                className="venobox play-btn mb-4"
                data-vbtype="video"
                data-autoplay="true"
              ></a>
            </div>

            <div
              className="col-xl-6 col-lg-6 icon-boxes d-flex flex-column align-items-stretch justify-content-center py-5 px-lg-5"
              data-aos="fade-left"
            >
              <h3>{translate('home.sectionabout.title')} </h3>
              <p>{translate('home.sectionabout.paragraf')}</p>

              {['1', '2', '3', '4'].map(x => (
                <div key={x} className="icon-box" data-aos="zoom-in" data-aos-delay="100">
                  <div className="icon" style={{ backgroundColor: '#e62333' }}>
                    {/* <FontAwesomeIcon size="2x" icon={translate("home.sectionabout.list." + x + ".image")} /> */}
                    <img src={translate('home.sectionabout.list.' + x + '.image')} alt="" />
                  </div>
                  <h4 className="title">
                    <a href={translate('home.sectionabout.list.' + x + '.href')}> {translate('home.sectionabout.list.' + x + '.title')}</a>
                  </h4>
                  <p className="description">{translate('home.sectionabout.list.' + x + '.description')}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Details Section */}

      <section id="details" className="details">
        <div className="ml-5" id="sustainable">
          <div className="row content">
            <div className="col-lg-6 order-1 order-md-2" data-aos="fade-left">
              <img src="/content/images/template/table-start.png" className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 pt-5 order-2 order-md-1" data-aos="fade-up">
              <h3>{translate('home.sectiondetail.2.title')}</h3>
              <p style={{ fontWeight: 700 }}> {translate('home.sectiondetail.2.paragraf1')}</p>
              <p style={{ fontWeight: 500 }}>{translate('home.sectiondetail.2.paragraf2')}</p>

              {['1', '2'].map(x => (
                <li style={{ fontFamily: 'verdana' }} key={x}>
                  {translate('home.sectiondetail.2.list.' + x)}
                </li>
              ))}

              <p>{translate('home.sectiondetail.2.footer')}</p>
            </div>
          </div>

          <div className="ml-5" id="efficient">
            <div className="row content">
              <div className="col-md-6 " data-aos="fade-right">
                <img src="/content/images/template/clock-start.png" className="img-fluid" alt="" />
              </div>
              <div className="col-md-6 pt-4" data-aos="fade-up">
                <h3>{translate('home.sectiondetail.1.title')}</h3>
                <p style={{ fontWeight: 700 }}>{translate('home.sectiondetail.1.paragraf1')}</p>
                <p style={{ fontWeight: 500 }}>{translate('home.sectiondetail.1.paragraf2')}</p>
                {['1', '2', '3', '4'].map(x => (
                  <li key={x}>{translate('home.sectiondetail.1.list.' + x)}</li>
                ))}
              </div>
            </div>
          </div>

          <div className="ml-5" id="flex">
            {/* Section 3 */}
            <div className="row content" id="section3">
              {/* Yazı */}
              <div className="col-md-6 pt-5 order-1" data-aos="fade-up">
                <h3>{translate('home.sectiondetail.3.title')}</h3>
                <p style={{ fontWeight: 700 }}>{translate('home.sectiondetail.3.paragraf1')}</p>
                <p style={{ fontWeight: 500 }}>{translate('home.sectiondetail.3.paragraf2')}</p>

                <ul>
                  {['1', '2'].map(x => (
                    <li key={x}>{translate('home.sectiondetail.3.list.' + x)}</li>
                  ))}
                </ul>
              </div>
              {/* Resim */}
              <div className="col-md-6 order-2" data-aos="fade-right">
                <img src="/content/images/template/rest-start.png" className="img-fluid" alt="" />
              </div>
            </div>

            {/* Section 4 */}
            <div className="row content" id="automation">
              {/* Yazı */}
              <div className="col-md-6 pt-5 order-1 order-md-2" data-aos="fade-up">
                <h3>{translate('home.sectiondetail.4.title')}</h3>
                <p style={{ fontWeight: 700 }}>{translate('home.sectiondetail.4.paragraf1')}</p>
                <p style={{ fontWeight: 500 }}>{translate('home.sectiondetail.4.paragraf2')}</p>

                <ul>
                  {['1', '2'].map(x => (
                    <li key={x}>{translate('home.sectiondetail.4.list.' + x)}</li>
                  ))}
                </ul>
              </div>
              {/* Resim */}
              <div className="col-md-6 order-2 order-md-1" data-aos="fade-left">
                <img src="/content/images/template/infinity-start.png" className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pay-As-You-Go Section */}

      <section id="payasgo" className="about">
        <div className="ml-5 " id="flex">
          <div className="row content">
            <div className="col-md-6 pt-5" data-aos="fade-up">
              <h3>Unlock Productivity through Tailored IT Solutions!</h3>
              <p>
                At StartupsReactor Ltd, we bring together a unique blend of expertise in software development and data management to deliver
                innovative, effective, and customised IT solutions that drive business growth and efficiency.
              </p>
              <p>
                With our exceptional team’s skills in software development ranging from Python and Java to .NET and more, we have
                successfully crafted robust applications, responsive websites, and integrated systems that meet our clients’ diverse needs.
                Also, we have successfully addressed our clients’ challenges in data management, BI analysis, data visualisation, etc.
              </p>
              <p>
                We would be honoured to introduce you to our budget-saver method which we call it ’Pay As We Go’. It will save you from the
                common hassle of making payments for a project you have not seen. Just drop us a line and we’ll get back to you for further
                details.
              </p>

              <li>Software Development (starts from £35 per hour)</li>
              <li>Data Management (starts from £25 per hour)</li>
            </div>
            <div className="col-md-6" data-aos="fade-right">
              <img src="/content/images/template/rest-start.png" className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
